import { FC, ReactNode } from "react";
import useSuperAdmin from "./useSuperAdmin";

const SuperAdmin: FC<{ children: ReactNode }> = ({ children }) => {
  const isSuperAdmin = useSuperAdmin();
  return isSuperAdmin ? <>{children}</> : null;
};

export default SuperAdmin;
